import { NgModule } from '@angular/core';
import { SimplePageComponent } from './pages/simple-page/simple-page.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { HomeComponent } from './pages/home/home.component';
import { AlleventsComponent } from './pages/allevents/allevents.component';
import { FacultadesInstitutosComponent } from './components/facultades-institutos/facultades-institutos.component';
import { FacultadesComponent } from './pages/facultades/facultades.component';
//import { SlideGenericPageComponent } from './pages/slide-generic-page/slide-generic-page.component';
import { ArancelesComponent } from '../aranceles/pages/aranceles/aranceles.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { AutoridadesComponent } from './pages/autoridades/autoridades.component';
import { NotFountComponent } from './pages/not-fount/not-fount.component';
import { BusquedaAvanzadaComponent } from '../busqueda/pages/busqueda-avanzada/busqueda-avanzada.component';
import { PreUniversidadComponent } from './pages/pre-universidad/pre-universidad.component';
import { PosgradosGeneralDosComponent } from '../posgrados/pages/posgrados-general-dos/posgrados-general-dos.component';
import { PosgradosGeneralUnoComponent } from '../posgrados/pages/posgrados-general-uno/posgrados-general-uno.component';
import { PosgradosComponent } from '../posgrados/pages/posgrados/posgrados.component';
import { CursosListadoComponent } from '../cursos/pages/cursos-listado/cursos-listado.component';
import { CursosComponent } from '../cursos/pages/cursos/cursos.component';
import { CarrerasDeGradoComponent } from '../ingreso/pages/carreras-de-grado/carreras-de-grado.component';
import { IngresoComponent } from '../ingreso/pages/ingreso/ingreso.component';
import { DetalleCursoComponent } from '../cursos/pages/detalle-curso/detalle-curso.component';


const routes: Routes = [
  { path: '404', component: NotFountComponent },
  { path: 'ingreso', component: IngresoComponent },
  { path: 'ingreso/:id', component: IngresoComponent },
  { path: 'posgrados', component: PosgradosComponent },
  { path: "posgrados/:id", component: PosgradosComponent, }, 
  { path: 'educacion-continua', component: CursosListadoComponent },
  { path: 'educacion-continua/:id', component: DetalleCursoComponent },

  { path: ':redirect', component: RedirectComponent },
  { path: 'error', redirectTo: 'es/home', canLoad: [AuthGuard] },
  { path: 'notFound', redirectTo: 'es/home', canLoad: [AuthGuard] },
  { path: '', redirectTo: 'es/home', canLoad: [AuthGuard], pathMatch: 'full' },
  { path: ':language/home', component: HomeComponent, canActivate: [AuthGuard], canLoad: [AuthGuard] },
  { path: '', redirectTo: ':language/home', canLoad: [AuthGuard], pathMatch: 'full' },
  { path: ':language/materias-del-curso-de-ingreso', component: PreUniversidadComponent },
  { path: ':language/aranceles-buenosaires', component: ArancelesComponent },
  { path: ':language/aranceles-rosario', component: ArancelesComponent },
  { path: ':language/aranceles-mendoza', component: ArancelesComponent },
  { path: ':language/aranceles-parana', component: ArancelesComponent },
  { path: ':language/busqueda/:data', component: BusquedaAvanzadaComponent }, //por palabra clave

  { path: ':language/educacion-continua', component: CursosListadoComponent },
  { path: ':language/educacion-continua/:id', component: DetalleCursoComponent },


  { path: ':language/ingreso', component: IngresoComponent },
  { path: ':language/ingreso/:id', component: IngresoComponent },

  { path: ':language/posgrados', component: PosgradosComponent },
  { path: ":language/posgrados/:id", component: PosgradosComponent, }, 
  
  
  { path: ':language/posgrados/elegi-tu-posgrado', component: PosgradosComponent },



  { path: ":language/facultades/:seccion/curso-acreditable/:id", component: PosgradosGeneralUnoComponent, },
  { path: ":language/facultades/:seccion/maestria/:id", component: PosgradosGeneralUnoComponent, },
  { path: ":language/facultades/:seccion/doctorado/:id", component: PosgradosGeneralUnoComponent, },
  { path: ":language/facultades/:seccion/posdoctorado/:id", component: PosgradosGeneralUnoComponent, },
  { path: ":language/facultades/:seccion/postitulo/:id", component: PosgradosGeneralUnoComponent, },
  { path: ":language/facultades/:seccion/curso-de-posgrado/:id", component: PosgradosGeneralUnoComponent, },
  { path: ":language/facultades/:seccion/curso-online/:id", component: PosgradosGeneralUnoComponent, },
  { path: ":language/facultades/:seccion/especializacion/:id", component: PosgradosGeneralUnoComponent, },
  { path: ":language/facultades/:seccion/posgrado-online/:id", component: PosgradosGeneralUnoComponent, },
  { path: ':language/facultades-e-institutos', component: FacultadesInstitutosComponent },
  { path: ':language/todas-las-carreras-de-la-uca', component: FacultadesInstitutosComponent },

  { path: ":language/facultades/:venue/carrera-de-grado/:carrer", component: CarrerasDeGradoComponent, },
  { path: ":language/facultades/:venue/ciclo-de-licenciatura/:carrer", component: CarrerasDeGradoComponent, },
  { path: ":language/facultades/:venue/ciclo-de-complementacion-curricular/:carrer", component: CarrerasDeGradoComponent, },
  { path: ":language/facultades/:venue/tecnicatura/:carrer", component: CarrerasDeGradoComponent, },
  { path: ":language/facultades/:venue/profesorado/:carrer", component: CarrerasDeGradoComponent, },
  { path: ":language/facultades/:venue/pregrado/:carrer", component: CarrerasDeGradoComponent, },

  { path: ':language/facultades/:venue/:type/:carrer/autoridades', component: AutoridadesComponent },
  { path: ':language/facultades/:venue/:type/:carrer/:id', component: PosgradosGeneralDosComponent },

  { path: ':language/cursos-de-educacion-continua/:venue/programa-ejecutivo/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/curso-intensivo/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/actividades/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/jornada/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/taller/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/curso-acreditable/:carrer', component: CursosComponent },

  { path: ':language/cursos-de-educacion-continua/:venue/curso-de-posgrado-online/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/diplomatura/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/maestria/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/doctorado/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/postitulo/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/curso-de-posgrado/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/curso/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/curso-online/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/especializacion/:carrer', component: CursosComponent },
  { path: ':language/cursos-de-educacion-continua/:venue/posgrado-online/:carrer', component: CursosComponent },
 // { path: ':language/facultades/:venue/:type/:carrer/:generic', component: SlideGenericPageComponent },
  { path: ':language/facultades/:venue', component: FacultadesComponent },
  { path: ':language/calendario/:month/:year', component: AlleventsComponent },
  { path: ':language/calendario/:month/:year/:venueCalendar', component: AlleventsComponent },

  {
    path: ':language/:title/:nivel2/:nivel3/:nivel4/:nivel5/:nivel6/:nivel7', children: [
      { path: '**', component: SimplePageComponent }
    ]
  },
  {
    path: ':language/:title/:nivel2/:nivel3/:nivel4/:nivel5/:nivel6', children: [
      { path: '**', component: SimplePageComponent }
    ]
  },
  {
    path: ':language/:title/:nivel2/:nivel3/:nivel4/:nivel5', children: [
      { path: '**', component: SimplePageComponent }
    ]
  },

  {
    path: ':language/:title/:nivel2/:nivel3/:nivel4', children: [
      { path: '**', component: SimplePageComponent }
    ]
  },
  {
    path: ':language/:title/:nivel2/:nivel3', children: [
      { path: '**', component: SimplePageComponent }
    ]
  },
  {
    path: ':language/:title/:nivel2', children: [
      { path: '**', component: SimplePageComponent }
    ]
  },
  {
    path: ':language/:title', children: [
      { path: '**', component: SimplePageComponent }
    ]
  },

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GeneralRoutingModule { }
